import React, { useState, useEffect } from 'react';
import { Typography, Card, Table, Button, Space, Tag, Input, Row, Col, App } from 'antd';
import { SearchOutlined, EyeOutlined, DownloadOutlined } from '@ant-design/icons';
import { formatDateBeijing } from '../utils/datetime';

const { Title, Text } = Typography;

const API_BASE_URL = process.env.REACT_APP_API_URL;

const TechnicalStandards = () => {
  const { message } = App.useApp();
  const [loading, setLoading] = useState(false);
  const [standards, setStandards] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });

  const loadStandards = async (page = 1, pageSize = 10) => {
    setLoading(true);
    try {
      const params = new URLSearchParams({
        page: page,
        page_size: pageSize,
        search: searchText,
      });

      const response = await fetch(`${API_BASE_URL}/industry/standards?${params}`);
      
      if (response.ok) {
        const data = await response.json();
        setStandards(data.data);
        setPagination({
          current: page,
          pageSize: pageSize,
          total: data.total,
        });
      } else {
        message.error('加载标准数据失败');
      }
    } catch (error) {
      console.error('加载标准数据失败:', error);
      message.error('加载标准数据失败');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadStandards();
  }, [searchText]);

  const getLevelTag = (level) => {
    const colors = {
      '国家标准': 'red',
      '行业标准': 'blue',
      '地方标准': 'green',
    };
    return <Tag color={colors[level] || 'default'}>{level}</Tag>;
  };

  const columns = [
    {
      title: '标准编号',
      dataIndex: 'code',
      key: 'code',
      width: '18%',
    },
    {
      title: '标准名称',
      dataIndex: 'name',
      key: 'name',
      width: '32%',
    },
    {
      title: '标准级别',
      dataIndex: 'level',
      key: 'level',
      width: '12%',
      render: (level) => getLevelTag(level),
    },
    {
      title: '实施日期',
      dataIndex: 'implementation_date',
      key: 'implementation_date',
      width: '17%',
      render: (date) => formatDateBeijing(date) || '-',
    },
    {
      title: '操作',
      key: 'action',
      width: '15%',
      render: (_, record) => (
        <Space>
          <Button type="link" icon={<EyeOutlined />} size="small">
            预览
          </Button>
          <Button type="primary" icon={<DownloadOutlined />} size="small">
            下载
          </Button>
        </Space>
      ),
    },
  ];

  const handleTableChange = (pagination) => {
    loadStandards(pagination.current, pagination.pageSize);
  };

  return (
    <div>
      <div style={{ marginBottom: '24px' }}>
        <Title level={2} style={{ marginBottom: '8px' }}>技术标准</Title>
        <Text type="secondary">国家和行业标准规范库</Text>
      </div>

      <Card style={{ marginBottom: '24px' }}>
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={12} md={8}>
            <Input
              placeholder="搜索标准名称或编号"
              prefix={<SearchOutlined />}
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              allowClear
            />
          </Col>
        </Row>
      </Card>

      <Card>
        <Table
          columns={columns}
          dataSource={standards}
          loading={loading}
          rowKey="id"
          pagination={{
            current: pagination.current,
            pageSize: pagination.pageSize,
            total: pagination.total,
            showSizeChanger: true,
            showTotal: (total) => `共 ${total} 个标准`,
          }}
          onChange={handleTableChange}
        />
      </Card>
    </div>
  );
};

export default TechnicalStandards;
